import React from "react";
import { Row, Col } from "react-bootstrap";
import '../../../src/App.css';
import './ServicesSection.css'

import services from '../../assets/services_logo.png';
import tool from '../../assets/tool.png'
import aut from '../../assets/automatizacion_smart.png'
import barras from '../../assets/barras_small.png';
import coments from '../../assets/coments.png';
import axes from '../../assets/happy_axes.png';
import logo from '../../assets/logo_png_para_web.png';
import ck from '../../assets/checklist.png';


const ServicesSection= () => {
  return(
    <section id="services-section">
      <Row>
        <Row>
          {/* logo-services */}
          <Col lg={9} className="offset-lg-3 paddingTop50px text-start">
            <Col lg={12}>
              <img src={services} alt="Services Logo" className="img-fluid"/>
              <p className="fs-1 font-nunito fw-bold text-start services-title">
                Estrategias Inteligentes para<br/>
                PYMEs con 
                <img src={logo} alt="Data Dos" className="logo-services img-fluid" />
              </p>
            </Col>
            {/* Recuadro Amarillo */}
            <Col lg={8} className="offset-lg-1 square-services1">
              <Row>
                <Col lg={2} className="">
                  <img src={barras} alt="Icons" className="img-fluid" />
                </Col>
                <Col lg={10}>
                  <Row>
                    <Col lg={12}>
                      <p className="fs-5 font-montserrat text-start">
                        Crecimiento Acelerado con Datos
                      </p>
                    </Col>
                    <Col lg={12}>
                      <p className="fs-6 font-inter text-start paddingLeft3_per">
                      Impulsar el crecimiento mediante la identificación de nuevas <br />
                      oportunidades a partir del análisis de datos históricos y predictivos.
                      </p>
                    </Col>
                  </Row>
                  
                </Col>
              </Row>              
            </Col>
            {/* Recuadro Azul Oscuro */}
            <Col lg={8} className="offset-lg-2 square-services2 marginTop5_per">
              <Row>
                <Col lg={2} className="">
                  <img src={aut} alt="Icon Automatización de tareas" className="img-fluid" />
                </Col>
                <Col lg={10}>
                  <Row>
                    <Col lg={12}>
                      <p className="fs-5 font-montserrat text-start">
                        Crecimiento Acelerado con Datos
                      </p>
                    </Col>
                    <Col lg={12}>
                      <p className="fs-6 font-inter text-start paddingLeft3_per">
                      Impulsar el crecimiento mediante la identificación de nuevas <br />
                      oportunidades a partir del análisis de datos históricos y predictivos.
                      </p>
                    </Col>
                  </Row>
                  
                </Col>
              </Row>              
            </Col>            
          </Col>
          
          <Col lg={12} className="">
            <Row>
              {/* Icono Axes */}
              <Col lg={4} className="contenedor-axes">
                <img src={axes} alt="Icons" className="img-fluid" />              
              </Col>
              <Col lg={8} className="">
                <Row>
                  {/* Recuadro Verde */}
                  <Col lg={9} className="offset-lg-2 square-services3 marginTop5_per">
                    <Row>
                      <Col lg={2} className="text-start">
                        <img src={tool} alt="Icons" className="img-fluid" />
                      </Col>
                      <Col lg={10}>
                        <Col lg={12}>
                          <p className="fs-5 font-montserrat text-start">
                            Análisis Predictivo para la Toma de Decisiones
                          </p>
                        </Col>
                        <Col lg={12}>
                          <p className="fs-6 font-inter text-start paddingLeft3_per">
                          Usar el análisis predictivo para optimizar las decisiones y <br/>
                          adelantarse a las demandas del mercado, incrementando la <br/>
                          competitividad y cuota de mercado.
                          </p>
                        </Col>                        
                      </Col>
                    </Row>
                    
                  </Col>
                  {/* Recuadro Lila */}
                  <Col lg={9} className="offset-lg-2 square-services4">
                    <Row>
                      <Col lg={2} className="text-start">
                        <img src={ck} alt="Icons" className="img-fluid" />
                      </Col>
                      <Col lg={10}>
                        <Col lg={12}>
                          <p className="fs-5 font-montserrat text-start">
                            Optimización de Tareas y Recursos
                          </p>
                        </Col>
                        <Col lg={12}>
                          <p className="fs-6 font-inter text-start paddingLeft3_per">
                          Optimizar la gestión de los empleados, reduciendo la carga de <br/>
                          trabajo innecesaria y liberando tiempo para que el equipo se <br/>
                          concentre en tareas que realmente generen valor a la empresa.
                          </p>
                        </Col>                        
                      </Col>
                    </Row>
                    
                  </Col>              
                </Row>
              </Col>
            </Row>            
          </Col>

          
          <Col lg={9} className="offset-lg-3 text-start">
            {/* Recuadro Celeste */}
            <Col lg={8} className="offset-lg-2 square-services5">
              <Row>
                <Col lg={2} className="text-start">
                  <img src={coments} alt="Icon Automatización de tareas" className="img-fluid" />
                </Col>
                <Col lg={10}>
                  <Row>
                    <Col lg={12}>
                      <p className="fs-5 font-montserrat text-start">
                        Conocer lo que tus Clientes Piensan de tu Empresa
                      </p>
                    </Col>
                    <Col lg={12}>
                      <p className="fs-6 font-inter text-start paddingLeft3_per">
                        Monitorear el impacto de las decisiones empresariales en la percepción
                        del público.<br/>
                        Beneficios: Fidelización, a través, de la satisfacción de los clientes.
                      </p>
                    </Col>
                  </Row>
                  
                </Col>
              </Row>              
            </Col>            
          </Col>
        </Row>
      </Row>
      <Col lg={12} className="marginTop5_per">
        <p className="fs-5 font-montserrat text-center custom-bg spacing_letter_6px">
          Mientras tú dudas, otros ya están ganando mercado.
        </p>
      </Col>
    </section>
  );
}
export default ServicesSection;